export const CARNATION = '#F66F5B';
export const SALMON = '#FF8A65';
export const GRANNY_SMITH_APPLE = '#91e291';
export const BLACK = '#000';
export const APRICOT_PEACH = '#fcccc4';
export const ATHENS_GRAY = '#e6e8eb';
